import {CheckUrlResponseStatus} from './hot-api/promotions';
import axios from './index';

enum PromotionsPlan {
  PromoteImages = 7,
}

export interface TPromotionImage {
  model_id?: string;
  width?: number;
  height?: number;
  id?: string;
  phash?: number;
  src: string;
}

export enum ProfileType {
  Model = 'model',
  Place = 'place',
  Unknown = 'unknown',
}

export interface TCommonProfile {
  ads_category: number[];
  base_name: string;
  title: string | null;
  description: string | null;
  category_ids: number[];
  domain_id: number;
  geo_location_ids: number[];
  shot_profile_url: string;
  images: {
    [key: string]: TPromotionImage[];
  };
  is_agency: null;
  models: {
    [key: string]: string;
  };
  name: string;
  page_id: number;
  phone: string;
  profile_url: string;
  profile_url_user: string;
  hot_profile_url: string;
  site_id: number;
}

export interface TModel extends TCommonProfile {
  type: ProfileType.Model;
}

export interface TPlace extends TCommonProfile {
  type: ProfileType.Place;
}

export type TProfile = TModel | TPlace;

export interface ProfilesResponse {
  criteria: string[];
  profiles: Array<TProfile>;
  site: null;
  check_url_status: CheckUrlResponseStatus;
  check_url: {
    isEscortCategory: boolean | undefined;
    success: boolean;
    notFound: boolean;
    notAccessible: boolean;
    redirectToExternal: boolean;
    message: string;
  };
}

interface GetProfileByContactsParams {
  phone?: string;
  onlyfans?: string;
  profile_url?: string;
  limit?: number;
  ad?: 'image';
}

export const getProfileByContacts = (params: GetProfileByContactsParams) =>
  axios.get<ProfilesResponse>('/profile/get-profile-by-contact', {
    params,
  });

export const checkUniqueness = (url: string) =>
  axios.get('/profile/promotion-uniqueness', {
    params: {
      plan_id: PromotionsPlan.PromoteImages,
      urls: encodeURI(url),
    },
  });
